import ActionNode from './add_action';
import { Box } from '@mui/material';
import ConditionalEdge from './conditional_edge';
import ConditionEdge from './condition_edge';
import ConditionItemNode from './condition_item_node';
import ConditionNode from './condition_node';
import CustomEdge from './custom_edge';
import EmailNode from './email_node';
import EndConitionNode from './end_condition_node';
import { fetchAutomationThunk } from '../../redux/thunks/automation';
import PhoneNode from './phone_node';
import SetConditionComponent from './set_condition';
import SetEmailComponent from './set_email';
import SetSMSComponent from './set_sms';
import SetTimerComponent from './set_timer';
import SimpleEdge from './simple_edge';
import TimerNode from './timer_node';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Controls, ReactFlow, ReactFlowProvider } from '@xyflow/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import '@xyflow/react/dist/style.css';
import '@xyflow/react/dist/base.css';

// Define node types
const nodeTypes = {
  email: EmailNode,
  condition: ConditionNode,
  phone: PhoneNode,
  timer: TimerNode,
  action: ActionNode,
  addCondition: ConditionItemNode,
  emailConditionItem: EmailNode,
  phoneConditionItem: PhoneNode,
  timerConditionItem: TimerNode,
  endCondition: EndConitionNode
};

const WorkflowBuilder: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();
  const { flags } = useSelector((state: RootState) => state.automation);
  const nodes = useSelector((state: RootState) => state.workflow.nodes);
  const edges = useSelector((state: RootState) => state.workflow.edges);
  // const { fitView } = useReactFlow();

  useEffect(() => {
    const fetchWorkFlow = async () => {
      try {
        await dispatch(fetchAutomationThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
      } catch (e) {
        // Catch errors
      }
    };
    fetchWorkFlow();
  }, []);

  // useEffect(() => {
  //   if (nodes.length > 0) {
  //     // 🔹 Find the bounding box of all nodes
  //     const minX = Math.min(...nodes.map((node) => node.position.x));
  //     const maxX = Math.max(...nodes.map((node) => node.position.x));
  //     const minY = Math.min(...nodes.map((node) => node.position.y));
  //     const maxY = Math.max(...nodes.map((node) => node.position.y));

  //     const centerX = (minX + maxX) / 2;
  //     const centerY = (minY + maxY) / 2;

  //     // 🔹 Set viewport to center the workflow
  //     setViewport({ x: -centerX + (window.innerWidth / 2), y: -centerY + (window.innerHeight / 2), zoom: 1 });
  //   }
  // }, [nodes]);

  if (flags.isAddingPhone) {
    return <SetSMSComponent />;
  } else if (flags.isAddingEmail) {
    return <SetEmailComponent />;
  } else if (flags.isAddingDuration) {
    return <SetTimerComponent />;
  } else if (flags.isAddingCondition) {
    return <SetConditionComponent />;
  }

  return (
    <ReactFlowProvider>
      <Box boxSizing="border-box" width="100%" height="75vh">
        <ReactFlow
          style={{
            backgroundColor: 'rgb(248, 247, 250)'
          }}
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          edgeTypes={{
            custom: CustomEdge,
            conditionEdge: ConditionEdge,
            conditionalEdge: ConditionalEdge,
            simpleEdge: SimpleEdge
          }}
          fitView
        >
          {/* <MiniMap /> */}
          <Controls />
          {/* <Background /> */}
        </ReactFlow>
      </Box>
    </ReactFlowProvider>
  );
};

export default WorkflowBuilder;

